import React from "react";
import { 
  APIProvider, 
  Map, 
  AdvancedMarker
} from '@vis.gl/react-google-maps';

import GoogleMapsReadyGate from '../../components/GoogleMapsReadyGate';
import classes from './StudioMap.module.css';

const isFiniteCoordinate = (value) => Number.isFinite(Number(value));

const StudioMapCanvas = ({ center, mapOptions }) => (
  <GoogleMapsReadyGate
    requireMarker
    fallback={<div className={classes.mapContainer} />}
  >
    <div className={classes.mapContainer}>
      <Map
        options={mapOptions}
        mapId={'bf51a910020fa25a'}
        style={{ width: '100%', height: '100%' }}
        defaultCenter={center}
        defaultZoom={12}
        mapTypeId='terrain'
        gestureHandling={'none'}
        disableDefaultUI={false}
        mapTypeControl={false}
        streetViewControl={false}
        fullscreenControl={false}
        zoomControl={false}
        scrollwheel={false}
        draggable={false}
        panControl={false}
        rotateControl={false}
        scaleControl={false}
      >
          <AdvancedMarker position={center}>
                <div className={classes.markerContainerOpen}>
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 80 81" fill="none">
                    <circle opacity="0.3" cx="40" cy="40.1934" r="39.75" fill="#DF315A" stroke="#DF315A" strokeWidth="0.5"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <circle cx="10" cy="10.1934" r="9.75" fill="#DF315A" stroke="#DF315A" strokeWidth="0.5"/>
                </svg>
                </div>
          </AdvancedMarker>
      </Map>
    </div>
  </GoogleMapsReadyGate>
);

const MapComponent = ({ latitude, longitude }) => {
    const center = { lat: Number(latitude), lng: Number(longitude) };
    const mapOptions = {
        maxZoom: 14,
        mapTypeId: 'terrain',
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        clickableIcons: false,
    };  

    const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

    if (!GOOGLE_API_KEY || !isFiniteCoordinate(latitude) || !isFiniteCoordinate(longitude)) {
      return <div className={classes.mapContainer} />;
    }
  
    return (
      <APIProvider apiKey={GOOGLE_API_KEY} libraries={['marker']}>
        <StudioMapCanvas center={center} mapOptions={mapOptions} />
      </APIProvider>
    );
};  

export const StudioMap = ({ latitude, longitude, marginTop }) => {

  return (
    // <div className={classes.container} style={{ marginTop: marginTop ? "40px" : "0px", marginBottom: marginTop ? "40px" : "0px" }}>
    <div className={classes.container} style={{ marginBottom: marginTop ? "40px" : "0px" }}>
        <h1 className='titleSemibold3' style={{ color: "var(--dark-grey)" }}>Standort</h1>
        <div className={classes.mapOutsideContainer}>
            <MapComponent latitude={latitude} longitude={longitude} />
        </div>
        <span className="slimRegularSmall">Der genaue Standort wird nach der Buchung mitgeteilt.</span>
    </div>
  );
};

export default StudioMap;
